import { State } from '../../types';

export const minnesota: State = {
  name: 'Minnesota',
  abbreviation: 'MN',
  terms: [
    {
      word: 'Aitkin',
      phonetic: 'Aye-kin',
      // audioUrl: '/audio/aitkin.mp3',
      description: 'A city in Aitkin County, often mispronounced as "Ate-kin."'
    },
    {
      word: 'Bemidji',
      phonetic: 'Buh-midge-ee',
      // audioUrl: '/audio/bemidji.mp3',
      description: 'A city in Beltrami County, commonly mispronounced as "Bee-midge-ee."'
    },
    {
      word: 'Chokio',
      phonetic: 'Sha-kie-oh',
      // audioUrl: '/audio/chokio.mp3',
      description: 'A city in Stevens County, often mispronounced as "Show-key-oh."'
    },
    {
      word: 'Cloquet',
      phonetic: 'Kloh-kay',
      // audioUrl: '/audio/cloquet.mp3',
      description: 'A city in Carlton County, commonly mispronounced as "Clo-kwet."'
    },
    {
      word: 'Edina',
      phonetic: 'Ee-dine-uh',
      // audioUrl: '/audio/edina.mp3',
      description: 'A city in Hennepin County, often mispronounced as "Ed-in-uh."'
    },
    {
      word: 'Ely',
      phonetic: 'Ee-lee',
      // audioUrl: '/audio/ely.mp3',
      description: 'A city in Saint Louis County, commonly mispronounced as "Ee-lie."'
    },
    {
      word: 'Faribault',
      phonetic: 'Fair-boh',
      // audioUrl: '/audio/faribault.mp3',
      description: 'A city in Rice County, often mispronounced as "Fair-uh-balt."'
    },
    {
      word: 'Isanti',
      phonetic: 'Eye-san-tee',
      // audioUrl: '/audio/isanti.mp3',
      description: 'A city in Isanti County, commonly mispronounced as "Ee-san-tee."'
    },
    {
      word: 'Lutsen',
      phonetic: 'Loot-sen',
      // audioUrl: '/audio/lutsen.mp3',
      description: 'An unincorporated community in Cook County, often mispronounced as "Lut-sen."'
    },
    {
      word: 'Mahtomedi',
      phonetic: 'Mah-toe-me-die',
      // audioUrl: '/audio/mahtomedi.mp3',
      description: 'A city in Washington County, commonly mispronounced as "Mat-toe-me-die."'
    },
    {
      word: 'New Prague',
      phonetic: 'New Pray-g',
      // audioUrl: '/audio/new_prague.mp3',
      description: 'A city in Le Sueur and Scott counties, often mispronounced as "New Prog."'
    },
    {
      word: 'Shakopee',
      phonetic: 'Shock-uh-pee',
      // audioUrl: '/audio/shakopee.mp3',
      description: 'A city in Scott County, commonly mispronounced as "Sha-ko-pee."'
    },
    {
      word: 'Wayzata',
      phonetic: 'Why-zet-uh',
      // audioUrl: '/audio/wayzata.mp3',
      description: 'A city in Hennepin County, often mispronounced as "Way-zat-uh."'
    },
    {
      word: 'Winona',
      phonetic: 'Wuh-noh-nuh',
      // audioUrl: '/audio/winona.mp3',
      description: 'A city in Winona County, commonly mispronounced as "Why-noh-nuh."'
    }
  ]
};